<template>
  <div class="row mx-0 mb-4">
    <div class="col-6 ps-0 pe-1 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <div v-if="editVertrag.id != 0" class="row mx-1 mb-4">
          <div class="col-6">
            <div class="mb-2">
              <label for="vertrag-doc-id" class="form-label">Dokument ID</label>
              <input type="text" class="form-control" id="vertrag-doc-id" maxlength="20" v-model="editVertrag.docId" />
            </div>

            <div>
              <label for="vertrag-action-id" class="form-label">Action ID</label>
              <input type="text" class="form-control" id="vertrag-action-id" maxlength="20" v-model="editVertrag.actionId" />
            </div>
          </div>

          <div class="col">
            <p class="mb-2">Vertragstyp</p>
            <div class="d-flex">
              <div class="form-check me-3">
                <input class="form-check-input" type="radio" name="vertragNeuvertrag" id="vertragNeuvertrag" :value="0" v-model="editVertrag.type" />
                <label class="form-check-label" for="vertragNeuvertrag">Neuvertrag</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="radio" name="vertragNachtrag" id="vertragNachtrag" :value="1" v-model="editVertrag.type" />
                <label class="form-check-label" for="vertragNachtrag">Nachtrag</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mx-1">
          <div class="col">
            <label for="vertrag-beginn" class="form-label">Vertragsbeginn</label>
            <input type="date" class="form-control" id="vertrag-beginn" v-model="startDatumString" @blur="onVertragsbeginnChange()" />
          </div>

          <div class="col">
            <label for="vertrag-ende" class="form-label">Vertragsende</label>
            <input type="date" class="form-control" id="vertrag-ende" v-model="endDatumString" @blur="onVertragsendeChange()" />
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 ps-1 pe-0 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <label for="vertrag-delete" class="form-label">Löschdatum</label>
        <input type="date" class="form-control" id="vertrag-delete" v-model="deleteDatumString" @blur="onDeleteDatumChange()" />
      </div>
    </div>
  </div>

  <h2>Vertragsparteien</h2>
  <div class="row mx-0 mb-4">
    <div class="col-6 ps-0 pe-1 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h3>Vertragspartner 1</h3>

          <SelectVertragsparteiModal :index="1" @select-partner="setPartner" />
        </div>

        <div class="row mb-2">
          <div class="col-7">
            <label for="partei-1-unternehmen" class="form-label">Unternehmen</label>
            <input type="text" class="form-control" id="partei-1-unternehmen" v-model="editVertrag.vertragspartei1.unternehmen" />
          </div>

          <div class="col-5">
            <label for="partei-1-unternehmenzusatz" class="form-label">Zusatz</label>
            <input type="text" class="form-control" id="partei-1-unternehmenzusatz" v-model="editVertrag.vertragspartei1.unternehmenzusatz" />
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-2">
            <label for="partei-1-anrede" class="form-label">Anrede</label>
            <input type="text" class="form-control" id="partei-1-anrede" v-model="editVertrag.vertragspartei1.anrede" />
          </div>

          <div class="col-5">
            <label for="partei-1-vorname" class="form-label">Vorname</label>
            <input type="text" class="form-control" id="partei-1-vorname" v-model="editVertrag.vertragspartei1.vorname" />
          </div>

          <div class="col-5">
            <label for="partei-1-name" class="form-label">Name</label>
            <input type="text" class="form-control" id="partei-1-name" v-model="editVertrag.vertragspartei1.name" />
          </div>
        </div>

        <div class="mb-2">
          <label for="partei-1-strasse" class="form-label">Straße & Hausnummer</label>
          <input type="text" class="form-control" id="partei-1-strasse" v-model="editVertrag.vertragspartei1.strasse" />
        </div>

        <div class="row mb-2">
          <div class="col-4">
            <label for="partei-1-plz" class="form-label">PLZ</label>
            <input type="text" class="form-control" id="partei-1-plz" v-model="editVertrag.vertragspartei1.plz" />
          </div>

          <div class="col">
            <label for="partei-1-ort" class="form-label">Ort</label>
            <input type="text" class="form-control" id="partei-1-ort" v-model="editVertrag.vertragspartei1.ort" />
          </div>
        </div>

        <div>
          <label for="partei-1-land" class="form-label">Land</label>
          <input type="text" class="form-control" id="partei-1-land" v-model="editVertrag.vertragspartei1.land" />
        </div>
      </div>
    </div>

    <div class="col-6 ps-1 pe-0 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h3>Vertragspartner 2</h3>

          <div>
            <span class="me-3">
              <SelectVertragsparteiModal :index="2" @select-partner="setPartner" />
            </span>
            <SelectMitarbeiterModal :index="2" @select-mitarbeiter="setMitarbeiter" />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-7">
            <label for="partei-2-unternehmen" class="form-label">Unternehmen</label>
            <input type="text" class="form-control" id="partei-2-unternehmen" v-model="editVertrag.vertragspartei2.unternehmen" />
          </div>

          <div class="col-5">
            <label for="partei-2-unternehmenzusatz" class="form-label">Zusatz</label>
            <input type="text" class="form-control" id="partei-2-unternehmenzusatz" v-model="editVertrag.vertragspartei2.unternehmenzusatz" />
          </div>
        </div>

        <div class="row mb-5">
          <div class="col-2">
            <label for="partei-2-anrede" class="form-label">Anrede</label>
            <input type="text" class="form-control" id="partei-2-anrede" v-model="editVertrag.vertragspartei2.anrede" />
          </div>

          <div class="col-5">
            <label for="partei-2-vorname" class="form-label">Vorname</label>
            <input type="text" class="form-control" id="partei-2-vorname" v-model="editVertrag.vertragspartei2.vorname" />
          </div>

          <div class="col-5">
            <label for="partei-2-name" class="form-label">Name</label>
            <input type="text" class="form-control" id="partei-2-name" v-model="editVertrag.vertragspartei2.name" />
          </div>
        </div>

        <div class="mb-2">
          <label for="partei-2-strasse" class="form-label">Straße & Hausnummer</label>
          <input type="text" class="form-control" id="partei-2-strasse" v-model="editVertrag.vertragspartei2.strasse" />
        </div>

        <div class="row mb-2">
          <div class="col-4">
            <label for="partei-2-plz" class="form-label">PLZ</label>
            <input type="text" class="form-control" id="partei-2-plz" v-model="editVertrag.vertragspartei2.plz" />
          </div>

          <div class="col">
            <label for="partei-2-ort" class="form-label">Ort</label>
            <input type="text" class="form-control" id="partei-2-ort" v-model="editVertrag.vertragspartei2.ort" />
          </div>
        </div>

        <div class="">
          <label for="partei-2-land" class="form-label">Land</label>
          <input type="text" class="form-control" id="partei-2-land" v-model="editVertrag.vertragspartei2.land" />
        </div>

        <hr class="my-3" />

        <div class="row mb-2">
          <div class="col">
            <label for="partei-2-man" class="form-label">Mandant</label>
            <input type="text" class="form-control" id="partei-2-man" v-model="persMan" @input="updatePersGuidFromInputChange" />
          </div>

          <div class="col">
            <label for="partei-2-ak" class="form-label">Abrechnungskreis</label>
            <input type="text" class="form-control" id="partei-2-ak" v-model="persAk" @input="updatePersGuidFromInputChange" />
          </div>

          <div class="col">
            <label for="partei-2-pers" class="form-label">Personal Nr.</label>
            <input type="text" class="form-control" id="partei-2-pers" v-model="persNr" @input="updatePersGuidFromInputChange" />
          </div>
        </div>

        <div class="fw-bold">Guid: {{ editVertrag.personaldatenGuid }}</div>
      </div>
    </div>
  </div>

  <h2>Weitere Informationen</h2>
  <div class="row mx-0">
    <div class="col-2 ps-0 pe-1 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <p><strong>Unterschrift 1</strong></p>

          <SelectSignaturModal :index="1" @select-signatur="setSignatur" />
        </div>

        <div class="mb-3">
          <label for="unterschrift1-zeichnung" class="form-label">Zeichnung</label>
          <input type="text" class="form-control" id="unterschrift1-zeichnung" v-model="editVertrag.zeichnung1" />
        </div>

        <div class="mb-3">
          <label for="unterschrift1-unterschrift" class="form-label">Unterschrift / Name</label>
          <input type="text" class="form-control" id="unterschrift1-unterschrift" v-model="editVertrag.unterschrift1" />
        </div>

        <div class="mb-3">
          <label for="unterschrift1-funktion" class="form-label">Funktion (Deutsch)</label>
          <input type="text" class="form-control" id="unterschrift1-funktion" v-model="editVertrag.funktion1" />
        </div>

        <div>
          <label for="unterschrift1-funktionEN" class="form-label">Funktion (Englisch)</label>
          <input type="text" class="form-control" id="unterschrift1-funktionEN" v-model="editVertrag.funktion1EN" />
        </div>
      </div>
    </div>

    <div class="col-2 px-1 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <p><strong>Unterschrift 2</strong></p>

          <SelectSignaturModal :index="2" @select-signatur="setSignatur" />
        </div>

        <div class="mb-3">
          <label for="unterschrift2-zeichnung" class="form-label">Zeichnung</label>
          <input type="text" class="form-control" id="unterschrift2-zeichnung" v-model="editVertrag.zeichnung2" />
        </div>

        <div class="mb-3">
          <label for="unterschrift2-unterschrift" class="form-label">Unterschrift / Name</label>
          <input type="text" class="form-control" id="unterschrift2-unterschrift" v-model="editVertrag.unterschrift2" />
        </div>

        <div class="mb-3">
          <label for="unterschrift2-funktion" class="form-label">Funktion (Deutsch)</label>
          <input type="text" class="form-control" id="unterschrift2-funktion" v-model="editVertrag.funktion2" />
        </div>

        <div>
          <label for="unterschrift2-funktionEN" class="form-label">Funktion (Englisch)</label>
          <input type="text" class="form-control" id="unterschrift2-funktionEN" v-model="editVertrag.funktion2EN" />
        </div>
      </div>
    </div>

    <div class="col-2 px-1 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <p><strong>Einstellungen</strong></p>

        <div class="mb-3">
          <label for="tariefgebiet" class="form-label">Tarifgebiet</label>
          <input type="text" class="form-control" id="tariefgebiet" v-model="editVertrag.tarifgebiet" />
        </div>

        <div class="mb-3">
          <label for="standort" class="form-label">Standort</label>
          <input type="text" class="form-control" id="standort" v-model="editVertrag.standort" />
        </div>

        <div class="mb-3">
          <label for="hrbpStandard" class="form-label">HRBP Standard</label>
          <input type="text" class="form-control" id="hrbpStandard" v-model="editVertrag.hrbpStandard" />
        </div>

        <div>
          <label for="auVorlage" class="form-label">AU Vorlage</label>
          <input type="text" class="form-control" id="auVorlage" v-model="editVertrag.auVorlage" />
        </div>
      </div>
    </div>

    <div class="col-3 px-1 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <p><strong>Kündigungsfrist während der Probezeit</strong></p>
        <div class="mb-3">
          <label for="kf-probezeit-de" class="form-label">Deutsch</label>
          <textarea class="form-control" id="kf-probezeit-de" rows="5" v-model="editVertrag.kfWaerendProbezeit"></textarea>
        </div>

        <div class="mb-4">
          <label for="kf-probezeit-en" class="form-label">Englisch</label>
          <textarea class="form-control" id="kf-probezeit-en" rows="5" v-model="editVertrag.kfWaerendProbezeitEN"></textarea>
        </div>
      </div>
    </div>

    <div class="col-3 ps-1 pe-0 d-flex">
      <div class="bg-white rounded shadow p-3 flex-fill">
        <p><strong>Kündigungsfrist nach der Probezeit</strong></p>
        <div class="mb-3">
          <label for="kf-nach-probezeit-de" class="form-label">Deutsch</label>
          <textarea class="form-control" id="kf-nach-probezeit-de" rows="5" v-model="editVertrag.kfNachProbezeit"></textarea>
        </div>

        <div class="mb-4">
          <label for="kf-nach-probezeit-en" class="form-label">Englisch</label>
          <textarea class="form-control" id="kf-nach-probezeit-en" rows="5" v-model="editVertrag.kfNachProbezeitEN"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { PropType, computed, ref, onMounted, watch } from 'vue';
  import { useStore } from '@/store';

  import { Vertrag } from '@/models/VertragModels';
  import { Vertragspartner, Signatur } from '@/models/VertragspartnerModels';
  import { Personaldaten } from '@/models/PersonaldatenModels';

  import SelectVertragsparteiModal from '@/components/Vertrag/SelectVertragsparteiModal.vue';
  import SelectMitarbeiterModal from '@/components/Vertrag/SelectMitarbeiterModal.vue';
  import SelectSignaturModal from '@/components/Vertrag/SelectSignaturModal.vue';
  //#endregion

  const { editVertrag, guid } = defineProps({
    editVertrag: {
      type: Object as PropType<Vertrag>,
      required: true,
    },

    guid: {
      type: String as PropType<string>,
      default: '',
    },
  });

  const store = useStore();

  //#region Vertragslaufzeit
  function formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // Vertragsbeginn
  const startDatumString = ref('');

  watch(
    () => editVertrag.vertragsBeginn,
    (val) => {
      if (val != null) {
        // remove 'T00:00:00' if present
        val = val.split('T')[0];
        startDatumString.value = val;
      } else {
        startDatumString.value = '';
      }
    },
    { immediate: true }
  );

  function onVertragsbeginnChange() {
    const value = startDatumString.value;

    if (!value) {
      editVertrag.vertragsBeginn = null;
      editVertrag.ddate = null;
      return;
    }

    // nur vollständige Datums-Strings akzeptieren
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return;
    }

    editVertrag.vertragsBeginn = value;

    setVertragDeleteDate();
  }

  function setVertragDeleteDate() {
    if (editVertrag.vertragsBeginn != null) {
      const [year, month, day] = editVertrag.vertragsBeginn.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      date.setMonth(date.getMonth() + 6);

      editVertrag.ddate = formatDate(date);
    }
  }

  // Vertragsende
  const endDatumString = ref('');

  watch(
    () => editVertrag.vertragsEnde,
    (val) => {
      if (val != null) {
        // remove 'T00:00:00' if present
        val = val.split('T')[0];
        endDatumString.value = val;
      } else {
        endDatumString.value = '';
      }
    },
    { immediate: true }
  );

  function onVertragsendeChange() {
    const value = endDatumString.value;

    if (!value) {
      editVertrag.vertragsEnde = null;
      return;
    }

    // nur vollständige Datums-Strings akzeptieren
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return;
    }

    editVertrag.vertragsEnde = value;
  }

  // Vertragsende
  const deleteDatumString = ref('');

  watch(
    () => editVertrag.ddate,
    (val) => {
      if (val != null) {
        // remove 'T00:00:00' if present
        val = val.split('T')[0];
        deleteDatumString.value = val;
      } else {
        deleteDatumString.value = '';
      }
    },
    { immediate: true }
  );

  function onDeleteDatumChange() {
    const value = deleteDatumString.value;

    if (!value) {
      editVertrag.ddate = null;
      return;
    }

    // nur vollständige Datums-Strings akzeptieren
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return;
    }

    editVertrag.ddate = value;
  }
  //#endregion

  //#region Vertragspartner
  const vertragspartner = computed(() => store.getters.vertragspartner);
  const signaturen = computed(() => store.getters.signaturen);

  function setPartner(index: number, partnerid: number) {
    if (index == 1) {
      selectedPartner1.value = vertragspartner.value.find((v: Vertragspartner) => v.id == partnerid);
      setVertragVertragspartner1();
    } else if (index == 2) {
      selectedPartner2.value = vertragspartner.value.find((v: Vertragspartner) => v.id == partnerid);
      setVertragVertragspartner2();
    }
  }

  const selectedPartner1 = ref<Vertragspartner | undefined>(undefined);
  function setVertragVertragspartner1() {
    if (selectedPartner1.value != null) {
      editVertrag.vertragspartei1.anrede = selectedPartner1.value.anrede;
      editVertrag.vertragspartei1.name = selectedPartner1.value.name;
      editVertrag.vertragspartei1.vorname = selectedPartner1.value.vorname;
      editVertrag.vertragspartei1.unternehmen = selectedPartner1.value.unternehmen;
      editVertrag.vertragspartei1.unternehmenzusatz = selectedPartner1.value.unternehmenzusatz;
      editVertrag.vertragspartei1.strasse = selectedPartner1.value.strasse;
      editVertrag.vertragspartei1.plz = selectedPartner1.value.plz;
      editVertrag.vertragspartei1.ort = selectedPartner1.value.ort;
      editVertrag.vertragspartei1.land = selectedPartner1.value.land;

      editVertrag.standort = selectedPartner1.value.standort;
      editVertrag.tarifgebiet = selectedPartner1.value.tarifgebiet;

      editVertrag.kfWaerendProbezeit = selectedPartner1.value.kfWaerendProbezeit;
      editVertrag.kfWaerendProbezeitEN = selectedPartner1.value.kfWaerendProbezeitEN;
      editVertrag.kfNachProbezeit = selectedPartner1.value.kfNachProbezeit;
      editVertrag.kfNachProbezeitEN = selectedPartner1.value.kfNachProbezeitEN;

      editVertrag.hrbpStandard = selectedPartner1.value.hrbpStandard;
      editVertrag.auVorlage = selectedPartner1.value.auVorlage;
    } else {
      editVertrag.vertragspartei1.anrede = '';
      editVertrag.vertragspartei1.name = '';
      editVertrag.vertragspartei1.vorname = '';
      editVertrag.vertragspartei1.unternehmen = '';
      editVertrag.vertragspartei1.unternehmenzusatz = '';
      editVertrag.vertragspartei1.strasse = '';
      editVertrag.vertragspartei1.plz = '';
      editVertrag.vertragspartei1.ort = '';
      editVertrag.vertragspartei1.land = '';

      editVertrag.standort = '';
      editVertrag.tarifgebiet = '';

      editVertrag.kfWaerendProbezeit = '';
      editVertrag.kfWaerendProbezeitEN = '';
      editVertrag.kfNachProbezeit = '';
      editVertrag.kfNachProbezeitEN = '';

      editVertrag.hrbpStandard = '';
      editVertrag.auVorlage = '';
    }
  }

  const selectedPartner2 = ref<Vertragspartner | undefined>(undefined);
  function setVertragVertragspartner2() {
    selectedMitarbeiter2.value = null;
    if (selectedPartner2.value != null) {
      editVertrag.vertragspartei2.anrede = selectedPartner2.value.anrede;
      editVertrag.vertragspartei2.name = selectedPartner2.value.name;
      editVertrag.vertragspartei2.vorname = selectedPartner2.value.vorname;
      editVertrag.vertragspartei2.unternehmen = selectedPartner2.value.unternehmen;
      editVertrag.vertragspartei2.unternehmenzusatz = selectedPartner2.value.unternehmenzusatz;
      editVertrag.vertragspartei2.strasse = selectedPartner2.value.strasse;
      editVertrag.vertragspartei2.plz = selectedPartner2.value.plz;
      editVertrag.vertragspartei2.ort = selectedPartner2.value.ort;
      editVertrag.vertragspartei2.land = selectedPartner2.value.land;

      editVertrag.personaldatenGuid = '';
    } else {
      editVertrag.vertragspartei2.anrede = '';
      editVertrag.vertragspartei2.name = '';
      editVertrag.vertragspartei2.vorname = '';
      editVertrag.vertragspartei2.unternehmen = '';
      editVertrag.vertragspartei2.unternehmenzusatz = '';
      editVertrag.vertragspartei2.strasse = '';
      editVertrag.vertragspartei2.plz = '';
      editVertrag.vertragspartei2.ort = '';
      editVertrag.vertragspartei2.land = '';

      editVertrag.personaldatenGuid = '';
    }
  }

  function setMitarbeiter(guid: string) {
    const persdata = store.getters.personaldaten.find((p: Personaldaten) => p.guid == guid);
    if (persdata != undefined) {
      selectedMitarbeiter2.value = persdata;
      setVertragMitarbeiter2();
    }
  }

  const selectedMitarbeiter2 = ref<Personaldaten | null>(null);

  if (guid != '') {
    const persdata = store.getters.personaldaten.find((p: Personaldaten) => p.guid == guid);
    if (persdata != undefined) {
      selectedMitarbeiter2.value = persdata;
      setVertragMitarbeiter2();
    }
  }

  function setVertragMitarbeiter2() {
    selectedPartner2.value = undefined;
    if (selectedMitarbeiter2.value != undefined) {
      editVertrag.vertragspartei2.unternehmen = '';
      editVertrag.vertragspartei2.unternehmenzusatz = '';

      editVertrag.vertragspartei2.anrede =
        selectedMitarbeiter2.value.geschlecht.toLowerCase() == 'm' ? 'Herr' : selectedMitarbeiter2.value.geschlecht.toLowerCase() == 'w' ? 'Frau' : '';

      editVertrag.vertragspartei2.name = selectedMitarbeiter2.value.name;
      editVertrag.vertragspartei2.vorname = selectedMitarbeiter2.value.vorname;
      editVertrag.vertragspartei2.strasse = selectedMitarbeiter2.value.strasse;
      editVertrag.vertragspartei2.plz = selectedMitarbeiter2.value.plz;
      editVertrag.vertragspartei2.ort = selectedMitarbeiter2.value.ort;
      editVertrag.vertragspartei2.land = selectedMitarbeiter2.value.land;

      editVertrag.personaldatenGuid = selectedMitarbeiter2.value.guid;
      setPersManAkFromGuid(selectedMitarbeiter2.value.guid);
    } else {
      editVertrag.vertragspartei2.anrede = '';
      editVertrag.vertragspartei2.name = '';
      editVertrag.vertragspartei2.vorname = '';
      editVertrag.vertragspartei2.unternehmen = '';
      editVertrag.vertragspartei2.unternehmenzusatz = '';
      editVertrag.vertragspartei2.strasse = '';
      editVertrag.vertragspartei2.plz = '';
      editVertrag.vertragspartei2.ort = '';
      editVertrag.vertragspartei2.land = '';

      editVertrag.personaldatenGuid = '';
    }
  }

  //#region Perosnal GUID (MAN_AK_PERS)
  const persMan = ref('');
  const persAk = ref('');
  const persNr = ref('');

  function updatePersGuidFromInputChange() {
    editVertrag.personaldatenGuid = `${persMan.value}_${persAk.value}_${persNr.value}`;

    // if (persMan.value && persAk.value && persNr.value) {
    //   editVertrag.personaldatenGuid = `${persMan.value}_${persAk.value}_${persNr.value}`;
    // } else {
    //   editVertrag.personaldatenGuid = '';
    // }
  }

  function setPersManAkFromGuid(guid: string) {
    // split string by '_' and set persMan, persAk and persNr
    const parts = guid.split('_');
    if (parts.length == 3) {
      persMan.value = parts[0];
      persAk.value = parts[1];
      persNr.value = parts[2];
    } else {
      persMan.value = '';
      persAk.value = '';
      persNr.value = '';
    }
  }
  //#endregion

  //#region Signaturen
  function setSignatur(index: number, signaturId: number) {
    if (index == 1) {
      selectedSignatur1.value = signaturen.value.find((v: Signatur) => v.id == signaturId);
      setVertragSignatur1();
    } else if (index == 2) {
      selectedSignatur2.value = signaturen.value.find((v: Signatur) => v.id == signaturId);
      setVertragSignatur2();
    }
  }

  const selectedSignatur1 = ref<Signatur | undefined>(undefined);
  function setVertragSignatur1() {
    if (selectedSignatur1.value != null) {
      editVertrag.zeichnung1 = selectedSignatur1.value?.zeichnung || '';
      editVertrag.unterschrift1 = selectedSignatur1.value?.unterschrift || '';
      editVertrag.funktion1 = selectedSignatur1.value?.funktion || '';
      editVertrag.funktion1EN = selectedSignatur1.value?.funktionEN || '';
    } else {
      editVertrag.zeichnung1 = '';
      editVertrag.unterschrift1 = '';
      editVertrag.funktion1 = '';
      editVertrag.funktion1EN = '';
    }
  }

  const selectedSignatur2 = ref<Signatur | undefined>(undefined);
  function setVertragSignatur2() {
    if (selectedSignatur2.value != undefined) {
      editVertrag.zeichnung2 = selectedSignatur2.value?.zeichnung || '';
      editVertrag.unterschrift2 = selectedSignatur2.value?.unterschrift || '';
      editVertrag.funktion2 = selectedSignatur2.value?.funktion || '';
      editVertrag.funktion2EN = selectedSignatur2.value?.funktionEN || '';
    } else {
      editVertrag.zeichnung2 = '';
      editVertrag.unterschrift2 = '';
      editVertrag.funktion2 = '';
      editVertrag.funktion2EN = '';
    }
  }
  //#endregion

  function initData() {
    // Set selected Vertragspartner 1
    const partner1 = vertragspartner.value.find(
      (v: Vertragspartner) =>
        v.name == editVertrag.vertragspartei1.name &&
        v.vorname == editVertrag.vertragspartei1.vorname &&
        v.unternehmen == editVertrag.vertragspartei1.unternehmen
    );
    if (partner1 != undefined) {
      selectedPartner1.value = partner1;
    }

    // Set selected Vertragspartner 2
    if (editVertrag.personaldatenGuid) {
      setPersManAkFromGuid(editVertrag.personaldatenGuid);

      const pers = store.getters.personaldaten.find((p: Personaldaten) => p.guid == editVertrag.personaldatenGuid);
      if (pers != undefined) {
        selectedMitarbeiter2.value = pers;
      }
    } else {
      const partner2 = vertragspartner.value.find(
        (v: Vertragspartner) =>
          v.name == editVertrag.vertragspartei2.name &&
          v.vorname == editVertrag.vertragspartei2.vorname &&
          v.unternehmen == editVertrag.vertragspartei2.unternehmen
      );
      if (partner2 != undefined) {
        selectedPartner2.value = partner2;
      }
    }
  }
  //#endregion

  onMounted(() => {
    if (editVertrag.id != 0) {
      initData();
    }
  });
</script>
